import {
    ClientApi,
    Configuration,
    CreditNoteApi,
    DocumentApi,
    E2EApi,
    HealthApi,
    LocationApi,
    OrderApi,
    PartnerApi,
    UserApi,
} from '@/generated';
import { type Env, getEnv } from '@/utils/envUtils';

const env: Env = getEnv();
const config = new Configuration({
    basePath: env?.VITE_API_BASE || '',
});

export const healthApi: HealthApi = new HealthApi(config);
export const clientApi: ClientApi = new ClientApi(config);
export const locationApi: LocationApi = new LocationApi(config);
export const orderApi: OrderApi = new OrderApi(config);
export const e2eApi: E2EApi = new E2EApi(config);
export const creditNoteApi: CreditNoteApi = new CreditNoteApi(config);
export const documentApi: DocumentApi = new DocumentApi(config);
export const partnerApi: PartnerApi = new PartnerApi(config);
export const userApi: UserApi = new UserApi(config);
